export const FREQUENCY_VALUES = ['hourly', 'daily', 'weekdays', 'custom'] as const;

export const WEEKDAY_VALUES = [
	'monday',
	'tuesday',
	'wednesday',
	'thursday',
	'friday',
	'saturday',
	'sunday',
] as const;
